import { numberMoney } from 'Data/format.js'

export function getAmount(item) {
  return numberMoney(Math.abs(item.amount))
}
